(() => {
  const buttons = document.querySelectorAll('[data-kelvin]');
  const setKelvin = value => {
    document.documentElement.classList.toggle('wdp-daylight', value === '5600');
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kelvin === value)));
  };
  try { setKelvin(localStorage.getItem('wdp-store-kelvin') === '5600' ? '5600' : '3200'); } catch (_) {}
  buttons.forEach(button => button.addEventListener('click', () => {
    setKelvin(button.dataset.kelvin);
    try { localStorage.setItem('wdp-store-kelvin', button.dataset.kelvin); } catch (_) {}
  }));
  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.toString());
  }));
  document.querySelectorAll('.wdp-prose .tabs').forEach(tabs => {
    const content = tabs.nextElementSibling;
    if (!content || !content.classList.contains('tabs-content')) return;
    tabs.querySelectorAll('a').forEach(link => {
      const id = link.getAttribute('href');
      const target = id && content.querySelector(id);
      if (target) {
        const heading = document.createElement('h3');
        heading.textContent = link.textContent;
        target.prepend(heading);
      }
    });
    tabs.hidden = true;
  });
})();
